import { render } from "./Wines.vue?vue&type=template&id=58a00abd"
import script from "./Wines.vue?vue&type=script&lang=js"
export * from "./Wines.vue?vue&type=script&lang=js"

import "./Wines.vue?vue&type=style&index=0&id=58a00abd&lang=css"
script.render = render

export default script